import { ImageUploader } from "./ImageUploader";
import { BusinessInfo } from "./BusinessInfo";
import { BrandColors } from "./BrandColors";
import { BrandStyling } from "./BrandStyling";


export const BrandingTab = () => {
  return (
    <>
      <ImageUploader />
      <BusinessInfo />
      <BrandColors />
      <BrandStyling />
    </>
  )
};